export default __webpack_public_path__ + "static/media/dynamicFlameReflect.10b53868.jpg";